import React from 'react';

import { FormOutlined } from '@ant-design/icons';

import RibbonButton from 'common/components/button/RibbonButton';

import Messages from 'i18n/messages/home';
import { useGlobalModal } from 'hooks';

export const WIDTH_CONTANT_PANE = 500;

const EditFolderDetail = (props) => {
  const { disabled } = props;

  const { MODAL_NAMES, openModal } = useGlobalModal();

  const clickEditFolderHandler = () => {
    openModal(MODAL_NAMES.EDIT_FOLDER);
  };

  return (
    <>
      <RibbonButton
        size='small'
        icon={<FormOutlined />}
        label={Messages.editFoldersRibbon}
        onClick={clickEditFolderHandler}
        disabled={disabled}
      />
    </>
  );
};

export default EditFolderDetail;
